<template>
    <section class="brand-intro" id="brand-intro">
        <div class="bg-wrap">
            <div class="bg"></div>
        </div>
        
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="title-area">
                        <h1>品牌介紹</h1>
                    </div>
                </div>
                <div class="col-12">
                    <div class="content-wrap">
                        <div class="img-wrap">
                            <img :src="brand_img" alt="">
                        </div>
                        <p class="text">
                            1944年創立於丹麥的哥本哈根，產品開發以實用為本。<br>
                            北歐經典設計更多次獲得國際大獎，在咖啡領域享譽世界！<br>
                            我們深信，幸福發生在每個平凡日常，從Bodum開始，<br>
                            讓「在家喝咖啡」，變成您日常最幸福的事！
                        </p>
                    </div>

                    <!-- <div class="video-box-wrap">
                        <div class="video-box">
                            <div class="play-btn"></div>
                            <iframe id="brand-video" src="https://www.youtube.com/embed/i7-CkbK8VBM?enablejsapi=1&html5=1&rel=0&amp;autoplay=0&mute=1&playsinline=1" frameborder="0" allowfullscreen></iframe>   
                        </div>
                        <p class="video-text">全聯福利中心BOGO FREE DANCE 買一送一</p>
                    </div> -->
                    
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import brand_img from '../assets/brand-img.svg';
// import logoSrc from '../assets/logo.svg';

export default {
    data(){
        return {
            brand_img,
        }
    },
    methods: {
        
    },
    mounted(){
        $('.play-btn').on('click', function(){


            //alert()

            $(this).css("display", "none");

            $('#brand-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
            
            gtag('event', '點擊', {
				'event_category': '首頁-品牌影片播放',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
        });

        console.log("BDIntro!!")


        //console.log(this.$route.name)
        

        

        



        

        

        //alert("mounted")
    }
}

</script>
<style lang="sass">



@import "~styles/global.sass"
.brand-intro
    overflow: hidden
    position: relative
    //padding-bottom: 50px
    @media (max-width: 991px)
        margin-bottom: 70px

    .bg-wrap
        clip: rect(0, auto, auto, 0)
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        .bg
            background-image: url('../assets/stone-bg.png')
            position: fixed
            display: block
            top: 0
            left: 0
            width: 100%
            height: 100%
            background-size: cover
            background-position: center center
            transform: translateZ(0)
            will-change: transform
            z-index: -1001
    &:before
        content: ''
        background-image: url('../assets/product-bg.png')
        position: fixed
        display: block
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-size: cover
        background-position: center center
        transform: translateZ(0)
        will-change: transform
        z-index: -1001
		
		
    

    .title-area
        background: $red
        width: 100vw
        text-align: center
        width: 100vw
        position: relative
        margin-left: -50vw
        //margin-top: 100px
        left: 50%
        color: white
        h1
            margin: 0
            padding: 20px 0
            letter-spacing: 2px
            font-weight: 300
    .content-wrap
        max-width: 50%
        margin: 0 auto
        text-align: center
        padding-top: 150px
        padding-bottom: 150px
        @media (max-width: 991px)
            max-width: 80%
            padding-top: 50px
            padding-bottom: 50px
        @media (max-width: 768px)
            max-width: 100%
            
            
        .img-wrap
            text-align: center
            margin-bottom: 50px
            img
                width: 80%
                margin: 0 auto
                @media (max-width: 768px)
                    max-width: 280px
        .text
            line-height: 30px
            color: black
            letter-spacing: 2px
            font-weight: 300
            @media (max-width: 513px)
                padding: 0 80px
            @media (max-width: 449px)
                padding: 0 50px
            @media (max-width: 378px)
                padding: 0 30px
            @media (max-width: 350px)
                padding: 0 20px
    .video-box-wrap
        .video-box
            position: relative
            .play-btn
                width: 100%
                height: 100%
                //border: 1px solid
                z-index: 10000
                position: absolute
                left: 0
                top: 0
        .video-text
            //padding: 0 10xp



</style>



// WEBPACK FOOTER //
// src/Index/BrandIntro.vue